<script setup lang="ts">
    import { useAiAssistantStore } from '~/stores/aiAssistantStore';
    import { ENTITY_LABEL_KEY_MAP } from '~/utils/aiEntityMeta';

    const emit = defineEmits<{
        'suggestion-clicked': [text: string];
    }>();

    const { t } = useTranslation();
    const authStore = useAuthStore();
    const store = useAiAssistantStore();
    const firstName = computed(() => authStore.authed?.firstName ?? '');

    const contextualPillText = computed(() => {
        if (!store.documentType) return null;
        const label = t(ENTITY_LABEL_KEY_MAP[store.documentType] ?? store.documentType);
        if (store.documentTitle) {
            return t('ai.greeting.work_on_titled', { type: label, title: store.documentTitle });
        }
        return t('ai.greeting.work_on', { type: label });
    });
</script>

<template>
    <div class="flex flex-col items-center justify-center h-full px-10 py-10">
        <h1 class="font-bricolage font-bold text-[24px] text-[#0F1020] m-0 mb-[10px] leading-none capitalize">
            {{ $t('ai.page.greeting', { name: firstName }) }}
        </h1>
        <p class="font-bricolage text-[15px] text-[#717171] m-0 mb-[28px]">
            {{ $t('ai.page.greeting_subtitle') }}
        </p>

        <div v-if="contextualPillText" class="flex flex-wrap justify-center gap-[10px] max-w-[640px]">
            <button
                type="button"
                class="px-[14px] py-[8px] rounded-full bg-white border border-[#E7E7E7] font-inter text-[12px] text-[#42484E] shadow-[0_1px_2px_rgba(0,0,0,0.03)] hover:border-[#FFC400] hover:text-[#0F1020] transition-all cursor-pointer"
                @click="emit('suggestion-clicked', contextualPillText)"
            >
                {{ contextualPillText }}
            </button>
        </div>
        <AiAssistantSuggestions
            v-else
            @suggestion-clicked="(text) => emit('suggestion-clicked', text)"
        />
    </div>
</template>
